export default "__VITE_ASSET__CW6WqoZA__"